import { getBaseBDWarehouseValue } from "../../utils/warehouses/warehouseHelpers.js";
import { useState, useEffect } from "react";
import "../../components/Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../components/Chrome/BrowseContext/hook.js";
const getWarehouseData = async (endpoint, headers) => {
  let warehouseData;
  try {
    const response = await fetch(
      endpoint,
      headers ? { headers } : void 0
    );
    const result = await response.json();
    warehouseData = (result == null ? void 0 : result.warehouse) || null;
  } catch (error) {
    console.warn("Failed to fetch warehouse data: ", error);
    return null;
  }
  return warehouseData;
};
function useBdWarehouseData(url, headers) {
  const { bdWarehouseNumber, miniBannerDetails } = useBrowseContext();
  const [warehouseData, setWarehouseData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const { addrType } = miniBannerDetails.values || {};
    if (!(bdWarehouseNumber == null ? void 0 : bdWarehouseNumber.value) || !addrType) {
      return;
    }
    const warehouseNumber = getBaseBDWarehouseValue(
      bdWarehouseNumber.value,
      addrType
    );
    const warehouseEndpoint = url.replace(
      "{{warehouse_id}}",
      warehouseNumber
    );
    const getHours = async () => {
      setIsLoading(true);
      const response = await getWarehouseData(warehouseEndpoint, headers);
      setIsLoading(false);
      setWarehouseData(response);
    };
    getHours();
  }, [miniBannerDetails, url]);
  return {
    isLoading,
    warehouseData
  };
}
export {
  getWarehouseData,
  useBdWarehouseData
};
